import type { TableRowSelection } from 'antd/es/table/interface';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import type { ButtonParams } from '../ControlButton/ControlButton';
import { ItemsCount } from '../ItemsCount';
import { PresetFilters } from '../filters/PresetFilters';
import type { PresetFiltersParams } from '../filters/PresetFilters/PresetFilters';
import { ResetFilters } from '../filters/ResetFilters';
import { SelectedRowsActionButton } from '../SelectedRowsActionButton';
import type { TableActionParams } from '../SelectedRowsActionButton/SelectedRowsActionButton';

interface TablePanelProps {
    hasPresetFilters: boolean;
    withSelectedCount?: boolean;
    presetFiltersParams?: PresetFiltersParams;
    selectedFilters?: Record<any, any>;
    selectedPreset?: number;
    onPresetFilterClick: (params: Record<any, any>, index?: number) => Promise<void> | void;
    count: number;
    withoutCount?: boolean;
    hasFilters: boolean;
    onResetFilters: () => void;
    smallButtonParams?: ButtonParams[];
    rowSelection?: TableRowSelection<any>;
    selectedRowsActions?: TableActionParams[];
}

export function TablePanel({
    hasPresetFilters,
    presetFiltersParams,
    selectedFilters,
    selectedPreset,
    onPresetFilterClick,
    count,
    withoutCount,
    hasFilters,
    onResetFilters,
    smallButtonParams,
    rowSelection,
    selectedRowsActions,
    withSelectedCount,
}: TablePanelProps) {
    const hasLeftSideContent =
        (hasPresetFilters && !!presetFiltersParams) || !withoutCount || !!smallButtonParams?.length;
    const hasRightSideContent = (!!withSelectedCount && !!rowSelection) || !!selectedRowsActions?.length;

    if (!hasLeftSideContent && !hasRightSideContent) {
        return null;
    }

    return (
        <div className="virtual_table_core_tablePanel">
            <div className="virtual_table_core_leftSide">
                {hasPresetFilters && presetFiltersParams && (
                    <PresetFilters
                        selectedFilters={selectedFilters}
                        selectedPreset={selectedPreset}
                        presetFiltersParams={{
                            ...presetFiltersParams,
                            onPresetFilter: onPresetFilterClick,
                        }}
                    />
                )}
                <div className="virtual_table_core_filtersRow">
                    {!withoutCount && (
                        <div className="virtual_table_core_filtersInfo">
                            <ItemsCount
                                count={count}
                                hasFilters={hasFilters}
                            />
                            {hasFilters && <ResetFilters onClick={onResetFilters} />}
                        </div>
                    )}
                    {smallButtonParams?.map(params => (
                        <Button
                            modifiers={[ButtonModifiers.Small]}
                            theme={ButtonTheme.Primary}
                            key={params.label}
                            onClick={params.onClick}
                            label={params.label}
                        />
                    ))}
                </div>
            </div>
            <div className="virtual_table_core_rightSide">
                {withSelectedCount && <ItemsCount selectedCount={rowSelection?.selectedRowKeys?.length} />}
                {!!selectedRowsActions?.length && (
                    <SelectedRowsActionButton
                        actions={selectedRowsActions}
                        selectedRowKeys={rowSelection?.selectedRowKeys ?? []}
                    />
                )}
            </div>
        </div>
    );
}
